import Repository from "./Repository";
const blogs = "/blogs";

export default {
  getBlogs: (params) => Repository.get(`${blogs}/`, { params: params }),
  getBlog: (id) => Repository.get(`${blogs}/${id}/`),
  createBlog: (blogData) => Repository.post(`${blogs}/`, blogData),
  updateBlog: (id, blogData) => Repository.patch(`${blogs}/${id}/`, blogData),
  deleteBlog: (id) => Repository.delete(`${blogs}/${id}/`),
  getPublishedBlogs: (params) =>
    Repository.get(`${blogs}/get_published/`, { params: params }),
  getMissingImages: (params) =>
    Repository.get(`${blogs}/get_missing_images/`, { params: params }),
};
